export const environment = {
  production: true,
  apiurl: 'https://trustii-api-preprod.azurewebsites.net/api',
  apiV2url: 'https://api-trustii-v2-preprod.azurewebsites.net/api',
  reCaptchaKey: '6LchFvQUAAAAAA71N1aFtguVy_AwfOQwMy12vczq'
};
